import { useEffect } from 'react';

export const useScrollToTop = () => {
  useEffect(() => {
    // 페이지 마운트 시 상단으로 스크롤
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // 모바일 Safari를 위한 추가 처리
    if (document.body.scrollIntoView) {
      document.body.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }, []);
}; 